import React from 'react'
import classNames from 'classnames'
import {useController} from 'react-hook-form'
import NumberFormat from 'react-number-format'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import {trans} from 'Src/utilities/Helpers'

const PhoneNumber = () => {
  const inputName = INPUT_NAMES.PHONE
  const {control, phoneRequired} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: inputName,
  })

  return (
    <div className="md:tw-w-2/5" aria-live="assertive" aria-atomic="false">
      <label
        htmlFor={inputName}
        className={classNames('input-label tw-mb-2', {required: phoneRequired})}
      >
        {trans('phone_number')}
      </label>
      <NumberFormat
        type="tel"
        id={inputName}
        className="input-field tw-w-full md:tw-placeholder-transparent"
        format="(###) ###-####"
        aria-required={phoneRequired}
        autoComplete="tel-national"
        value={field.value}
        getInputRef={field.ref}
        onBlur={field.onBlur}
        onValueChange={({value}) => field.onChange(value)}
      />
      {error?.message ? (
        <div>
          <span className="error">{error.message}</span>
        </div>
      ) : null}
    </div>
  )
}

export default PhoneNumber
